import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/$locale/_dashboard/")({
  component: DashboardHomePage,
});

function DashboardHomePage() {
  const { t } = useTranslation();

  return (
    <div className="py-6">
      <h1 className="text-2xl font-semibold">{t("overview")}</h1>
    </div>
  );
}
